
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply/[[...slug]]",
      function () {
        return require("private-next-pages/apply/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply/[[...slug]]"])
      });
    }
  